// A scanned loyalty membership card (MEM:<number>) looked up by the server: { customer_id, name, first_name, last_name, email,
// contact_number, membership_number, loyalty_points, loyalty_points_amount }.
//
// The card can be scanned at any screen. Where an order is being finished (customer selection, checkout) the screen takes it at once
// (the 'scan:member' event, handled like 'scan:voucher'); anywhere else it is remembered for a short while and picked up by the next
// customer-selection screen, so the cashier can scan the card while still taking the order.

export const MEMBER_EVENT = 'scan:member';
const KEY = 'pending_member';
export const PENDING_MAX_AGE_MS = 30 * 60 * 1000;

export const memberPoints = (member) => Number(member?.loyalty_points) || 0;

/** "Casey Jones (120 points)" / "Casey Jones (no points yet)" */
export function memberLabel(member) {
  const name = (member?.name || `${member?.first_name || ''} ${member?.last_name || ''}`).trim() || 'Member';
  const pts = memberPoints(member);
  return `${name} (${pts > 0 ? `${Math.round(pts * 100) / 100} points` : 'no points yet'})`;
}

export function rememberMember(member, now = Date.now()) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ at: now, member }));
  } catch {
    /* storage unavailable: the card is simply not remembered */
  }
}

export function forgetMember() {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

/** The remembered card if it is still fresh; either way it is forgotten (a card is used once). */
export function takePendingMember(now = Date.now()) {
  try {
    const raw = window.localStorage.getItem(KEY);
    window.localStorage.removeItem(KEY);
    if (!raw) return null;
    const { at, member } = JSON.parse(raw);
    return member && now - Number(at) <= PENDING_MAX_AGE_MS ? member : null;
  } catch {
    return null;
  }
}
